import { AppBar, Box, Button, Drawer, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import { WebStorageService } from "../services/WebStorageService";
import { CURRENT_USER } from "../contants/constants";
import { useState } from "react";
import { CurrentUser } from "../models/CurrentUser";
import { ContactSupport, Dashboard, Login, Person } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';

export default function PrivateLayout() {
    const webStorageService = new WebStorageService();
    const [user] = useState<CurrentUser>(webStorageService.getJson(CURRENT_USER));
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    if(user === null){
        navigate("/home");
    }

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
    };

    function onSignout(){
        webStorageService.clear();
        navigate("/home");
    }

    return (
        <Box sx={{ height: '100%' }}>
            <AppBar color="error" position="fixed" sx={{ display: "flex", flexDirection: "row" }}>
                {/* Desktop View*/}
                <Toolbar variant="regular" disableGutters sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, marginLeft: 2 }} >
                    <img src="navbar-logo.png" style={{ marginRight: 10 }}></img>
                    <Typography variant="h5">
                        PIPOY GAS
                    </Typography>
                </Toolbar>
                <Toolbar sx={{ display: { xs: "none", md: "flex" } }}>
                    <Link href="/my-dashboard" variant="button" sx={{ color: 'white', paddingX: 2 }} underline="none">Dashboard</Link>
                    <Link href="/my-contact-us" variant="button" sx={{ color: 'white', paddingX: 2 }} underline="none">Contact Us</Link>
                    <Link href="/my-profile" variant="button" sx={{ color: 'white', paddingX: 2 }} underline="none">My Profile</Link>
                    <Link component="button" variant="button" sx={{ color: 'white', paddingX: 2 }} underline="none" onClick={onSignout}>Sign out</Link>
                </Toolbar>

                {/* Mobile View*/}
                <Toolbar variant="regular" disableGutters sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} >
                    <Button onClick={toggleDrawer(true)} sx={{ color: 'white' }}>
                        <MenuIcon></MenuIcon>
                    </Button>
                    <Typography variant="h5">
                        PIPOY GAS
                    </Typography>
                </Toolbar>
                <Drawer open={open} onClose={toggleDrawer(false)}>
                    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
                        <List>
                            <Link href="/my-dashboard" underline="none">
                                <ListItem key="Dashboard" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <Dashboard></Dashboard>
                                        </ListItemIcon>
                                        <ListItemText primary="DASHBOARD" sx={{ color: "#d32f2f" }} />
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                            <Link href="/my-profile" underline="none">
                                <ListItem key="My Profile" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <Person></Person>
                                        </ListItemIcon>
                                        <ListItemText primary="MY PROFILE" sx={{ color: "#d32f2f" }} />
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                            <Link href="/my-contact-us" underline="none">
                                <ListItem key="Contact Us" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <ContactSupport></ContactSupport>
                                        </ListItemIcon>
                                        <ListItemText primary="CONTACT US" sx={{ color: "#d32f2f" }} />
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                            <Link href="/sign-in" onClick={onSignout} underline="none">
                                <ListItem key="Sign in" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <Login></Login>
                                        </ListItemIcon>
                                        <ListItemText color="#d32f2f" primary="SIGN OUT" sx={{ color: "#d32f2f" }} ></ListItemText>
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                        </List>
                    </Box>
                </Drawer>
            </AppBar>
            <Box sx={{ alignContent: "center", display: "flex", alignItems: "baseline", minHeight:"100%" }}>
                <Outlet></Outlet>
            </Box>
        </Box>
    )
}